import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import CategoryLayout from "@/components/feature/CategoryLayout";
import { categories, posts } from "@/mocks/anime";

const category = categories.find((c) => c.id === "review")!;
const list = posts.filter((p) => p.category === "review");

export default function Review() {
  return (
    <>
      <Navbar />
      <main>
        <CategoryLayout
          category={category}
          posts={list}
          description="私藏安利、深度漫评、剧情脑洞与角色分析，在这里和同好分享你对每一部番的热爱与观点，一起聊到天亮。"
        />
      </main>
      <Footer />
    </>
  );
}